import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { EduEmailValidator } from '../../../validators/edu-email.validator';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-create-user-dialog',
  standalone: true,
  imports: [
    MatFormFieldModule,
    FormsModule,
    MatSelectModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './create-user-dialog.component.html',
  styleUrl: './create-user-dialog.component.scss',
})
export class CreateUserDialogComponent implements OnInit {
  roleId = new FormControl(-1, [Validators.required]);
  newUserForm = new FormGroup({
    vendorName: new FormControl(''),
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    eduEmail: new FormControl(''),
  });

  userForm = new FormGroup({
    role: this.roleId,
    userInfo: this.newUserForm,
  });

  roleIds = [
    { value: 0, viewValue: 'Admin' },
    { value: 1, viewValue: 'Vendor' },
    { value: 2, viewValue: 'Student' },
  ];

  constructor(
    private userService: UserService,
    private dialogRef: MatDialogRef<CreateUserDialogComponent>
  ) {}
  ngOnInit(): void {
    this.roleId.valueChanges.subscribe((val) => {
      this.newUserForm.controls.vendorName.clearValidators();
      this.newUserForm.controls.eduEmail.clearValidators();
      this.newUserForm.reset();
      if (val == 1) {
        this.newUserForm.controls.vendorName.setValidators([
          Validators.required,
        ]);
        this.newUserForm.updateValueAndValidity();
      }
      if (val == 2) {
        this.newUserForm.controls.email.setErrors(null);
        this.newUserForm.controls.eduEmail.setValidators([
          Validators.required,
          Validators.email,
          EduEmailValidator,
        ]);
        this.newUserForm.updateValueAndValidity();
      }
    });
  }

  createUser() {
    const newUserValues = this.userForm.value;
    this.newUserForm.controls.vendorName.clearValidators();
    this.newUserForm.controls.eduEmail.clearValidators();
    this.userService.userCreatedByAdmin(newUserValues).subscribe({
      next: () => {
        this.dialogRef.close({ message: 'User successfully created!' });
      },
      error: () => {
        this.dialogRef.close({
          message: 'User could not be created. Please try again.',
        });
      },
    });
  }

  onCancel() {
    this.dialogRef.close();
  }
}
